export const overview = {
  slide1_title: "Business Development",
  slide2_title: "Consulting Services",
  slide3_title: "Interim Management",
  slide4_title: "Training & Coaching",
  slider_prev: "Previous slide",
  slider_next: "Next slide",
  slider_label: "Slide {{number}}",
  title: "Our Services",
  h1:
    "Comprehensive commercial and technical services for your sustainable business success. As an experienced local partner, we guide foreign ICT manufacturers through the development of new markets and offer tailored solutions for every single step of your expansion.",
  intro_p1:
    "We at NetBasis International offer foreign manufacturers from the telecommunications and IT industry a wide spectrum of commercial and technical services as well as consulting and training to support them quickly and efficiently on their way into new markets. Our clear focus lies on achieving your growth objectives throughout the entire German-speaking economic area (DACH region).",
  intro_p2:
    "To help you find the desired area of expertise more quickly, we have divided our portfolio into four specialized sections:",
  intro_p3:
    "If you want to actively involve us in your new business and have us perform real tasks, please look into \"Business Development\" to explore our various services and select what we can concretely do for you. If you would like to know us by your side as pure advisors, please have a look at \"Consulting\". If you wish to engage us \"for a limited time\" in one of our specialist areas, simply click directly on \"Interim Management\". Or, if you would like to draw on our know-how for pure training and coaching purposes, please browse the corresponding section.",
  section_title:
    "Together toward operational excellence and sustainable market success",
  intro_p4:
    "Whatever your idea may be, NetBasis International helps you precisely specify the goals and visions of your market entry plan. As on-site industry experts, we assist you in permanently reviewing all processes and agilely adapting them over and over again to the individual requirements of the new markets. In doing so, we do not view ourselves as an external service provider, but rather as loyal and fully integrated members of your own team who are deeply connected to your project. We possess the fine intuition and well-founded expertise for local market mechanisms that are absolutely essential to turn your international venture into a real and lasting success. Through this deep commitment and our clear focus on measurable results, we secure your strong and highly competitive market presence step by step.",
  strong_name: "NetBasis International",
  card1_title: "Business Development",
  card1_desc:
    "You want to actively involve us in your new business and have us perform real tasks? Then choose from our services.",
  card2_title: "Consulting Services",
  card2_desc:
    "You would like to have us at your side purely as consultants? Then see our consulting services.",
  card3_title: "Interim Management",
  card3_desc:
    "You want to temporarily engage us in one of our subject areas? Then learn more here.",
  card4_title: "Training & Coaching",
  card4_desc:
    "You want to query our expertise for pure training and/or coaching purposes? Then have a look around here.",
  read_more: "Read more",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const businessDevelopment = {
  title: "Business Development",
  hero_overlay: "Always your business in mind!",
  heroAlt: "Businessman plans business strategies and sales channels for ICT market entry in the DACH market.",
  intro:
    "NetBasis International assists its clients, either through introducing their existing products and services to new international markets or through building up new appropriate business opportunities for them. We create and develop effective and practical business strategies and provide the according implementation plans, we support our clients throughout the entire implementation period, and even longer, if requested.",
  benefits_title: "How you benefit from our __Business Development__ expertise:",
  svc0_name: "Business Presence",
  svc0_image: "https://net-basis.net/Bilder/duesseldorf-media-harbor-rhine-tower-business-location.webp",
  svc0_desc:
    "Establishing a strong presence in the DACH market through local sales structures and direct customer contacts.",
  svc1_name: "Full-Service Package",
  svc1_image: "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp",
  svc1_desc:
    "Complete care from market analysis and product positioning to ongoing sales and support.",
  svc2_name: "Consulting",
  svc2_image: "https://net-basis.net/Bilder/ict-market-entry-business-strategy-consulting.webp",
  svc2_desc:
    "Strategic consulting for your market entry – well-founded, pragmatic and tailored to your individual needs.",
  svc3_name: "Product Management",
  svc3_image: "https://net-basis.net/Bilder/ict-product-management-market-adaptation-modular-development.webp",
  svc3_desc:
    "Your success in the DACH region: We precisely adapt your ICT products to local standards, regulations and competition.",
  svc4_name: "Project Management",
  svc4_image: "https://net-basis.net/Bilder/project-management-planning-control-dach-market-entry.webp",
  svc4_desc:
    "Professional management and coordination of your market entry projects from planning to successful implementation.",
  svc5_name: "Market Analyses",
  svc5_image: "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp",
  svc5_desc:
    "Detailed analyses of the DACH markets with sound recommendations for your business strategy.",
  svc6_name: "Market Entry Strategies",
  svc6_image: "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp",
  svc6_desc:
    "Strategic expansion: We evaluate your market entry options and design the path to sustainable success in the DACH region.",
  svc7_name: "Import Management",
  svc7_image: "https://net-basis.net/Bilder/import-management-customs-clearance-dach-distribution.webp",
  svc7_desc:
    "Efficient handling of all import processes including customs clearance and supply chain optimisation.",
  svc8_name: "International Trade",
  svc8_image: "https://net-basis.net/Bilder/international-trade-dach-local-expertise.webp",
  svc8_desc:
    "Building and maintaining international trade relationships with a focus on long-term partnerships.",
  svc9_name: "Technical Support",
  svc9_image: "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp",
  svc9_desc:
    "Comprehensive technical support for your products in the DACH market by qualified specialists.",
  benefit_0: "Formulating marketing and promotional strategies",
  benefit_1: "Recommending important product adaptations and/or modifications",
  benefit_2: "Providing new product development opportunities",
  benefit_3: "Planning foreign operations and logistics",
  benefit_4: "Identifying appropriate distribution network",
  benefit_5: "Planning strategy implementation",
  benefit_6: "Identifying and evaluating potential technology transfer and licensing opportunities",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const consultingServices = {
  title: "Consulting Services",
  heroImage: "https://net-basis.net/Bilder/ict-market-entry-consulting-strategy-dach.webp",
  heroAlt: "Businesspeople review market data for DACH market entry, sales and marketing strategies.",
  heroClaimLine1: "Safe in new",
  heroClaimLine2: "markets",
  heroClaimLine3: "",
  strong_name: "NetBasis International",
  benefits_title: "How you benefit from our __Consulting__ expertise:",
  p1:
    "NetBasis International offers a full range of consulting services coming across from our own expertise and resources. The key to our client service is our ability to integrate our competence in functional areas with our experience in domain knowledge. We help our clients to find the best possible strategies and tactics to broaden their international business activities and to achieve their business goals in the shortest time possible.",
  p2: "",
  p3: "",
  benefit_0: "Evaluation of the client's potential in the new markets",
  benefit_1: "Definition of how to enter these new markets",
  benefit_2: "Adaptation to the environmental differences of these new markets",
  benefit_3: "Advisory service in the determination of the client's business goal",
  benefit_4: "Creation of a strategic sales and marketing plan to achieve the client's business objectives",
  benefit_5: "Help the client to plan and manage all activities involved in a successfull market entry",
  benefit_6: "Advising management support on cross-cultural integration issues",
  benefit_7: "Development of negotiation strategies and provision of requisite support",
  benefit_8: "Coordination and collaboration with potential business partners (manufacturers, distributors, resellers, etc.)",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const interimManagement = {
  title: "Interim Management",
  heroImage: "https://net-basis.net/Bilder/ict-interim-management-experts-dach-market-entry.webp",
  heroAlt: "Businessman selects experienced ICT managers to lead sales and projects in the DACH market.",
  heroClaimLine1: "Instant, flexible, expert, experienced ... temporary!",
  heroClaimLine2: "",
  strong_name: "NetBasis International",
  benefits_title: "How you benefit from our __Interim Management__ expertise:",
  p1:
    "{{strong}} offers you experienced interim managers who take on complex tasks quickly and in a targeted manner. Whether sales management, project management or operational management – we provide the right experts.",
  p2:
    "Our interim managers bring decades of experience in the IT and telecommunications industry and know the DACH markets in all their details. They are ready for immediate deployment and deliver measurable results from day one.",
  p3:
    "Use {{strong}} as your flexible pool of personnel resources. We bridge gaps, accompany transformation processes and ensure the smooth operation of your business activities.",
  benefit_0: "Rapid provision of highly qualified specialists",
  benefit_1: "Experienced managers with IT and telecom industry know-how",
  benefit_2: "Flexible deployment duration – from weeks to months",
  benefit_3: "Immediate operational impact without induction time",
  benefit_4: "Sales management and team building on site",
  benefit_5: "Project management for market entry projects",
  benefit_6: "Bridging of personnel bottlenecks",
  benefit_7: "Knowledge transfer and succession planning",
  benefit_8: "Cost-efficient alternative to personnel recruitment",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const trainingCoaching = {
  title: "Training & Coaching",
  heroImage: "https://net-basis.net/Bilder/ict-training-coaching-dach-market-entry.webp",
  heroAlt: "Businessman visualizes sales, leadership and intercultural competence goals in the DACH market.",
  heroClaimLine1: "Guided to\nyour goal!",
  strong_name: "NetBasis International",
  benefits_title: "How you benefit from our __Training & Coaching__ expertise:",
  p1:
    "{{strong}} optimally prepares you and your employees for the challenges of new markets. Our training and coaching programmes are practice-oriented, interculturally sound and tailored to your individual needs.",
  p2:
    "From sales training to cultural preparation to management coaching – we cover the entire spectrum you need for a successful market entry.",
  p3:
    "Our experienced trainers and coaches have many years of practical experience in the DACH region. They know not only the theory but also the daily challenges of business life.",
  benefit_0: "Sales training for the DACH market",
  benefit_1: "Intercultural communication and business etiquette",
  benefit_2: "German business culture and decision-making processes",
  benefit_3: "Negotiation techniques and conflict management",
  benefit_4: "Presentation techniques for German-speaking audiences",
  benefit_5: "Management coaching and team development",
  benefit_6: "Change management and transformation support",
  benefit_7: "Product training for sales teams",
  benefit_8: "Onboarding programmes for new employees",
  benefit_9: "Mentoring programmes for future managers",
  benefit_10: "Language training and Business German",
  benefit_11: "Remote team leadership and virtual collaboration",
  benefit_12: "Customer retention and relationship management",
  benefit_13: "Compliance and regulatory training",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const hero = {
  title: "Services",
  subtitle: "Tailored solutions for your success",
  description:
    "NetBasis International offers you a wide range of services for successful market entry into the DACH region. Learn more about our core competencies.",
};

export const cta = {
  title: "Ready for the next step?",
  subtitle:
    "Contact us for a non-binding initial consultation. We will show you how we can make your market entry a success.",
  button: "Get in touch",
};

export const partnership = {
  title: "Partnership",
  heroImage: "https://net-basis.net/Bilder/netbasis-partnership-dach-market-entry.webp",
  heroAlt: "Businessman offers a handshake for a trusted partnership and DACH market entry.",
  heroClaimLine1: "Strong through",
  heroClaimLine2: "partnership!",
  p1: "In the very moment words like \"international\" or \"abroad\" appear in any of your business thoughts and/or dealings, the ensuing exchanges will usually not be simple. Innumerable problems may occur and affect your schedule, bottom line and sanity, such as language barriers, less-than-trustworthy situations, sometimes time differences, and/or the inability to be there in person to see what is really going on.",
  p2: "NetBasis International is an established and experienced import management company and thereby your go-between that saves you from any potentially business-ending errors as you deal internationally.",
  p3: "Our international manufacturer partners profit from our knowledge and established presence in the DACH markets. As their importer we bring them in contact with all relevant local sales companies and organizations in only one step. Launching an outstanding product and/or solution can be so much easier with the right contacts and connections.",
  p4: "Our local distributor partners like the idea of a partnership with a local company, NetBasis International, by simultaneously and instantly having access to wide range of products and solutions of different foreign manufacturers.",
  p5: "NetBasis International is proud to already be associated with a number of important noncompetitive manufacturers in their business fields.",
  experience_heading: "Experience",
  experience_p1: "Markets change — knowledge, contacts, and experience remain.",
  experience_p2: "For almost two decades, NetBasis International has been building up foreign manufacturers and tech brands in the DACH region, establishing them in the market, and supporting them long-term. It is never just about pure distribution. It is about trust and deep understanding of both sides — the global brand looking to gain a foothold in a new market, and the local customer seeking a reliable partner.",
  experience_p3: "Good and reliable relationships with our partners are not a nice-to-have — they are the foundation for sustainable success and satisfied customers.",
  experience_p4: "Manufacturers come and go, but the ability to read markets and forge the right connections remains. Below you will find an excerpt of important partnerships from the last nearly twenty years.",
  experience_p5: "",
  manufacturers_heading: "Our Manufacturer Partners",
  manufacturer_0_name: "LeadDoubler ApS",
  manufacturer_0_logo: "https://net-basis.net/Bilder/Lead-Doubler-logo.png",
  manufacturer_0_desc: "Danish manufacturer of lead generation software",
  manufacturer_1_name: "Mondago Ltd",
  manufacturer_1_logo: "https://net-basis.net/Bilder/Mondago-logo.png",
  manufacturer_1_desc: "English manufacturer of CTI solutions",
  manufacturer_2_name: "Pinewood",
  manufacturer_2_logo: "https://net-basis.net/Bilder/Pinewood-logo.jpg",
  manufacturer_2_desc: "Belgian manufacturer of multimedia solutions",
  manufacturer_3_name: "Retell Call Recording",
  manufacturer_3_logo: "https://net-basis.net/Bilder/Re-Tell-logo.png",
  manufacturer_3_desc: "English manufacturer of call recording solutions",
  manufacturer_4_name: "Rohde & Schwarz Topex",
  manufacturer_4_logo: "https://net-basis.net/Bilder/Rohde-Schwarz-logo.jpg",
  manufacturer_4_desc: "Romanian manufacturer of GSM gateways",
  manufacturer_5_name: "Samsung",
  manufacturer_5_logo: "https://net-basis.net/Bilder/Samsung-logo.png",
  manufacturer_5_desc: "Collaboration in the area of their CTI solution",
  manufacturer_6_name: "Voice gear",
  manufacturer_6_logo: "https://net-basis.net/Bilder/Voice-Gear-logo.jpg",
  manufacturer_6_desc: "International trade brand for audio solutions",
  manufacturer_7_name: "Zenion",
  manufacturer_7_logo: "https://net-basis.net/Bilder/Zenion-logo.jpg",
  manufacturer_7_desc: "International trade brand for fanless mini PCs",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const businessPresence = {
  title: "Business Presence",
  heroImage: "https://net-basis.net/Bilder/duesseldorf-media-harbor-rhine-tower-business-location.webp",
  heroAlt: "Düsseldorf Media Harbor and Rhine Tower represent a local business presence in the DACH market.",
  heroClaimLine1: "Business Hub",
  heroClaimLine2: "Düsseldorf",
  benefits_title: "How you benefit from our __Business Presence__ expertise:",
  p1: "For many companies, entering new markets as well as their successful development involves considerable time and effort. Also, the sensitivities, different views and/or expectations of potential international business partners, who prefer to have a local contact person speaking their language and being familiar with their life habits, their country's law and their trade practices, are regularly underrated. Lack of market, country and language skills, and lack of human and/or financial resources thus represent considerable hurdles.",
  p2: "Here, NetBasis International helps with its service \"business presence\" as a link between your company and the new markets, to effectively overcome all sorts of difficulties and/or obstacles.",
  p3: "With a local commercial presence and address in Düsseldorf - not only introducing your company's name and giving you a local telephone number and contact person, but also doing YOUR complete local (and international) business in YOUR name – you will be excellently and cost-effectively positioned.",
  benefit_0: "Minimization of cost, effort, time and risk",
  benefit_1: "No need for your own legal presence in the field",
  benefit_2: "Direct market entry opportunities",
  benefit_3: "Favorable opportunity for a market and product test",
  benefit_4: "No separate need for personnel",
  benefit_5: "More efficient follow-up with existing contacts",
  benefit_6: "Relief of your own export department",
  benefit_7: "No language barriers, direct and simple communication",
  benefit_8: "Instant access to databases and mailing lists as well as integration into networks",
  benefit_9: "Best getting into business and/or transition to your own local branch",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const fullService = {
  title: "Full-Service Offer",
  heroImage: "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp",
  heroAlt: "Businessman uses a digital dashboard for a centrally managed ICT full-service offer.",
  heroClaimLine1: "Everything from",
  heroClaimLine2: "one source!",
  benefits_title: "How you benefit from our __Full-Service Package__ expertise:",
  p1: "NetBasis International is working for foreign companies as their extended arm in the new markets. From a broad portfolio of services, our manufacturer partners can individually and tailored to their needs select special support and assistance.",
  p2: "The most comprehensive approach, however, to enter a new market, and thus the best way to ensure a successful work, is our full-service package. Here our manufacturer partners keep a clear head for the business in their home markets and leave the complete development and support of the new markets to in close cooperation, of course.",
  p3: "With a full-service contract NetBasis International carries out the complete local business as well as the planning, execution and monitoring of all necessary tasks.",
  section1_title: "1. All Inclusive",
  section1_0: "Postal address and full office service",
  section1_1: "Technical and commercial product(s) evaluation(s)",
  section1_2: "Preparation of all necessary commercial and technical documents",
  section1_3: "Intensive Competition Analysis",
  section1_4: "Pricing",
  section1_5: "Commercialization of selected (or all) products (as your importer)",
  section1_6: "Official registration of products at authorities such as \"Stiftung EAR\" (only in terms of hardware)",
  section1_7: "Technical Support (levels to be defined)",
  section1_8: "We from NetBasis International are ready for developing your business (as your representative office) !",
  section2_title: "2. Practical",
  section2_0: "One contact person for YOUR questions/concerns as well as for your local customers – all that in the required languages (English, German)",
  section2_1: "Complete Sales, Marketing and Support on site \"in your name\"",
  section3_title: "3. Quick",
  section3_0: "No long start-up time. With us you are immediately ready for action",
  section3_1: "Direct concentration on the job itself",
  section3_2: "No delay in contacting potential customers and/or sales partner",
  section3_3: "Easy local customer calls/visits and trade fair participations",
  section4_title: "4. Close to the customer",
  section4_0: "Locally present without language and/or mentality barriers",
  section4_1: "Looking experienced, professional, reliable and customer-orientated",
  section4_2: "High agility, short reaction time",
  section5_title: "5. Cost-efficient",
  section5_0: "No costs for an expensive international office and personnel, no costly investments, little fixed costs",
  section5_1: "Clear and manageable monthly fixed charge plus commission on sales results (according to partner agreement)",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const bdConsulting = {
  title: "Consulting Services",
  heroImage: "https://net-basis.net/Bilder/ict-market-entry-business-strategy-consulting.webp",
  heroAlt: "Businessman marks Business Strategy for secure ICT entry into new markets.",
  heroClaimLine1: "Safe in",
  heroClaimLine2: "new markets!",
  heroClaimLine3: "",
  benefits_title: "How you benefit from our __Consulting__ expertise:",
  p1: "NetBasis International offers a full range of consulting services coming across from our own expertise and resources. The key to our client service is our ability to integrate our competence in functional areas with our experience in domain knowledge. We help our clients to find the best possible strategies and tactics to broaden their international business activities and to achieve their business goals in the shortest time possible.",
  benefit_0: "Evaluation of the client's potential in the new markets",
  benefit_1: "Definition of how to enter these new markets",
  benefit_2: "Adaptation to the environmental differences of these new markets",
  benefit_3: "Advisory service in the determination of the client's business goal",
  benefit_4: "Creation of a strategic sales and marketing plan to achieve the client's business objectives",
  benefit_5: "Help the client to plan and manage all activities involved in a successfull market entry",
  benefit_6: "Advising management support on cross-cultural integration issues",
  benefit_7: "Development of negotiation strategies and provision of requisite support",
  benefit_8: "Coordination and collaboration with potential business partners (manufacturers, distributors, resellers, etc.)",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const productManagement = {
  title: "Product Management",
  heroImage: "https://net-basis.net/Bilder/ict-product-management-market-adaptation-modular-development.webp",
  heroAlt: "Hands present a modular cube with red blocks for ICT product management.",
  heroClaimLine1: "Perfectly adapted!",
  heroClaimLine2: "Safely positioned!",
  benefits_title: "How you benefit from our __Product Management__ expertise:",
  p1: "NetBasis International offers its clients its very comprehensive expertise in the area of product management. We help to adapt, refine, alter, acclimatize, tailor and fashion their products, solutions and/or services to our markets. We assist our manufacturer partners to create product/solutions that people will want to buy and continue to use. We ensure that the customers' voice is not lost in the rush to an exciting technology. We take care of all duties to offer a complete and promising product.",
  p2: "",
  p3: "",
  benefit_0: "Launching, operating and managing a product/solution throughout its life cycle",
  benefit_1: "Assisting in the choice of the right idea for the right market",
  benefit_2: "Help determine what product developments to focus on",
  benefit_3: "Help defining general feature sets and convincing product/solution releases",
  benefit_4: "Discover new and innovative features to enrich products/solutions",
  benefit_5: "Consider areas like pricing, marketing and customer support to the technology",
  benefit_6: "Evaluating risks and trade-offs",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const projectManagement = {
  title: "Project Management",
  heroImage: "https://net-basis.net/Bilder/project-management-planning-control-dach-market-entry.webp",
  heroAlt: "Businessman creates a flowchart for secure project management during market entry.",
  heroClaimLine1: "Perfectly planned!",
  heroClaimLine2: "Safely managed!",
  benefits_title: "How you benefit from our __Project Management__ expertise:",
  p1: "NetBasis International supports its manufacturing partners' entire market entry with comprehensive project consulting and direct project management. Because precisely the plan of wanting to be present in new markets is a strategic and thus very important decision in most cases. And a failure shall/must be avoided. At the same time such a project is often extremely complex and requires a higher level of market-specific expertise, professional skills and specific focal point orientation, than typically being available in a company that is not on site.",
  p2: "",
  p3: "",
  benefit_0: "Take-over of planning, monitoring and control of a market entry project",
  benefit_1: "Support in the planning and coordination of the scope, the project deadlines, the costs, the financing and the necessary resources",
  benefit_2: "Execution of the entire local project controlling",
  benefit_3: "Help in the identification, analysis, evaluation and management of project risks",
  benefit_4: "Monitoring of the project progress and comparison with the project planning",
  benefit_5: "Continuous monitoring of adherence to schedules, progress on content and cost loyalty",
  benefit_6: "Permanent project information and communication with the manufacturer partner",
  benefit_7: "Assistance in all country and market specific legal matters",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const marketResearch = {
  title: "Market Research",
  heroImage: "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp",
  heroAlt: "Businessman analyzes digital market data for informed market entry decisions.",
  heroClaimLine1: "Understand markets!",
  heroClaimLine2: "Decide with confidence!",
  benefits_title: "How you benefit from our __Market Analyses__ expertise:",
  p1: "NetBasis International offers its clients a comprehensive package of market research services as a very important component of their business strategy and as a key factor to get advantage over competitors. We provide our clients with important information to understand the market needs, market size and established competition. We provide our clients with the business intelligence and research they need to make informed decisions.",
  p2: "",
  p3: "",
  benefit_0: "Analysis of market trends, activities and issues",
  benefit_1: "Assessment of market size, characteristics and trends",
  benefit_2: "Background reports on (foreign) competitors and their local presence, their clients and/or their partners / customers",
  benefit_3: "Marketing and management strategy identification",
  benefit_4: "Market definition by potential consumer groups",
  benefit_5: "Supplier, buyer and distributor identification",
  benefit_6: "Review of regulatory procedures and policies",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const marketEntryStrategy = {
  title: "Market Entry Strategy",
  heroImage: "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp",
  heroAlt: "Hand marks a red target segment in overlapping circles for the market entry strategy.",
  heroClaimLine1: "Heading for",
  heroClaimLine2: "your market share!",
  benefits_title: "How you benefit from our __Market Entry Strategies__ expertise:",
  p1: "NetBasis International is its clients' resource for identifying and developing options for starting operations in a foreign market. We undertake research to provide market intelligence that will support our clients' planning process, and ensures the best market presence for your business. Based upon our knowledge and expertise we help our manufacturer partners make key strategic decisions and grow their business into new markets.",
  benefit_0: "Performing market entry evaluations",
  benefit_1: "Assisting in the general decision which markets to invest into",
  benefit_2: "Providing planning and execution aid based on local market intelligence and expertise",
  benefit_3: "Offering thorough analysis of potential competitors and possible customers",
  benefit_4: "Accessing to our established distribution networks and thereby quickly gaining market share",
  benefit_5: "Ensuring mandatory and necessary local skills to successfully run a project",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const importManagement = {
  title: "Import Management",
  heroImage: "https://net-basis.net/Bilder/import-management-customs-clearance-dach-distribution.webp",
  heroAlt: "Stacked freight containers symbolize import management, customs clearance and local sales.",
  heroClaimLine1: "More than just",
  heroClaimLine2: "transport!",
  benefits_title: "How you benefit from our __Import Management__ expertise:",
  p1: "NetBasis International serves its foreign clients as their import department. We are experts in our line of business and our markets. We handle all import and local sales and marketing operations for our manufacturer partners. We are the sales link between our clients and the markets. Our clients immediately profit from our in-place networks and get immediate access to local business partners.",
  benefit_0: "Takeover of the entire import process, including customs clearance",
  benefit_1: "Correct classification of products (customs tariff codes), including exchange of information with all trading partners",
  benefit_2: "Ensure proper product labeling and packaging",
  benefit_3: "Legally compliant import execution, i.e. paying attention to prohibitions and restrictions",
  benefit_4: "Coverage of all financial and legal risks",
  benefit_5: "Correct supply to local dealers and/or distributors",
  benefit_6: "Arranging advertising, marketing and promotions",
  benefit_7: "Planning/organization of and participation in fairs/congresses",
  benefit_8: "Arranging local accounting and finance",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const internationalTrade = {
  title: "International Trade",
  heroImage: "https://net-basis.net/Bilder/international-trade-dach-local-expertise.webp",
  heroAlt: "Businessman points to a networked world map for international trade in the DACH market.",
  heroClaimLine1: "Overcoming borders!",
  heroClaimLine2: "With local know-how!",
  benefits_title: "How you benefit from our __International Trade__ expertise:",
  p1: "NetBasis International is its clients trusted trading partner in our markets. We help our foreign manufacturer partners engage in business activities with local partners. We perform necessary and relevant markets and trade research and investigations and maintain competitive trade knowledge. We assist our manufacturing partners to evaluate their business potential, customers, international partners, quality control, management and leadership, and financial issues.",
  p2: "",
  p3: "",
  benefit_0: "Assisting in contract and cost structure negotiations to achieve the most cost effective pricing structure, most acceptable payment terms and most reliable warranties",
  benefit_1: "Working with our clients' management and local law firms to approve and finalize new business proposals",
  benefit_2: "Giving insights and staying up-to-date on trade policies and regulations",
  benefit_3: "Providing support in obtaining necessary licenses and agreements for trading",
  benefit_4: "Responding to queries related to international trade procedures",
  benefit_5: "Processing import ruling requests and custom documentation and filings",
  benefit_6: "Providing for reliable delivery schedules by supply chain assistance",
  benefit_7: "Ensuring shipments conformity to domestic and international rules and regulations",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const technicalSupport = {
  title: "Technical Support",
  heroImage: "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp",
  heroAlt: "Hand with screwdriver uses a digital interface for technical support in the DACH market.",
  heroClaimLine1: "Customer service",
  heroClaimLine2: "with advice on site!",
  benefits_title: "How you benefit from our __Technical Support__ expertise:",
  p1: "NetBasis International offers full technical support to help customers fully leverage the value of the products/solutions represented by us. This enables our manufacturer partners to locally maintain a high availability of service. Our highly specialized assistance allows customers and partners to quickly and easily use, manage, and troubleshoot their products/solutions. Our direct link to our manufacturer partners thereby additionally assures the quality of our support.",
  p2: "",
  p3: "",
  benefit_0: "Answers to general questions about the use of products/solutions",
  benefit_1: "Assistance with specific operational information",
  benefit_2: "Provision of installation and setup instructions",
  benefit_3: "On-site installation and setup services",
  benefit_4: "Access to support by phone, email, and the web",
  benefit_5: "Remote access repair services",
  benefit_6: "Assistance in identifying and verifying the causes of suspected errors",
  benefit_7: "Solutions for identified errors or malfunctions",
  benefit_8: "Maintenance according to 'SLA's (Service Level Agreement)",
  benefit_9: "Multi-tiered/leveled technical support",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};